import React from "react";
import T from "prop-types";

import { PlaceholderText } from "2g-placeholder";

import { DateTime } from "b2b/renderers";

import useMessages from "./i18n/useMessages";

function TitleDescription({ loading, provozniInformace }) {
  const messages = useMessages();
  const { datumVytvoreni, datumUprava } = provozniInformace || {};

  return !loading ? (
    <div className="b2b-ProvozniInformaceDetailWidget-desciprion">
      <span>
        <span>{messages.desciptionCreated()}:</span>
        <DateTime val={datumVytvoreni} />
      </span>
      {datumVytvoreni !== datumUprava && (
        <span>
          <span>{messages.descriptionEdited()}:</span>
          <DateTime val={datumUprava} />
        </span>
      )}
    </div>
  ) : (
    <PlaceholderText>17. března</PlaceholderText>
  );
}

TitleDescription.propTypes = {
  loading: T.bool,
  provozniInformace: T.shape({
    datumVytvoreni: T.number,
    datumUprava: T.number
  })
};

export default React.memo(TitleDescription);
